import React from 'react';
import styled, { css } from 'styled-components';

import theme from '../../../../styled-components/dark';

type WrapperType = {
  $isEnded?: boolean;
  $isOut: boolean;
};

const Wrapper = styled.div<WrapperType>`
  ${({ $isEnded, $isOut }) => {
    if ($isEnded) {
      return css`
        --LineUpRacerInformation-backgroundColor: ${theme.LineUpRacerStats.ended.backgroundColor};
        --LineUpRacerInformation-color: ${theme.LineUpRacerStats.ended.color};
      `;
    }
    if ($isOut) {
      return css`
        --LineUpRacerInformation-backgroundColor: ${theme.LineUpRacerStats.out.backgroundColor};
        --LineUpRacerInformation-color: ${theme.LineUpRacerStats.out.color};
      `;
    }
    return css`
      --LineUpRacerInformation-backgroundColor: ${theme.LineUpRacerStats.default.backgroundColor};
      --LineUpRacerInformation-color: ${theme.LineUpRacerStats.default.color};
    `;
  }}
  background-color: var(--LineUpRacerInformation-backgroundColor);
  padding: 0 0.2em;
  border-radius: 0.3em;
`;

type LabelType = {
  $isOut: boolean;
};

const Label = styled.div<LabelType>`
  font-size: 0.8em;
  color: var(--LineUpRacerInformation-color);
  white-space: nowrap;
  font-weight: normal;
`;

type LineUpRacerInformationPropsType = {
  className?: string;
  content?: string;
  isOut: boolean;
};

const LineUpRacerInformation = ({ className = '', content, isOut }: LineUpRacerInformationPropsType) => {
  return content || isOut ? (
    <Wrapper className={className} $isOut={isOut}>
      <Label $isOut={isOut}>{isOut ? 'OUT' : content}</Label>
    </Wrapper>
  ) : null;
};

export default LineUpRacerInformation;
